import { render } from "./BaseDiscountCard.vue?vue&type=template&id=44d60dbb&scoped=true"
import script from "./BaseDiscountCard.vue?vue&type=script&lang=js"
export * from "./BaseDiscountCard.vue?vue&type=script&lang=js"

import "./BaseDiscountCard.vue?vue&type=style&index=0&id=44d60dbb&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d60dbb"]])

export default __exports__